// extracted by mini-css-extract-plugin
export var footer = "_q0-5";
export var fulfillmentInput = "_q0-0";
export var shipDateInput = "_q0-1";
export var shipmentModal = "_q0-2";
export var shipmentModalContent = "_q0-3";
export var tableContainer = "_q0-4";